import axios from 'axios';

const API_URL = process.env.VUE_APP_API_BASE_URL + 'guest/';

class GuestService {

  getReservation(guest_id) {
    var full_api_url = API_URL + "invitation?id=" + guest_id;

    return axios
      .get(full_api_url, { headers: { access_token: process.env.VUE_APP_API_KEY } })
      .then(response => {
        return response.data;
      });
  }

  signUp(user) {

    var nickname = (user.firstname + user.lastname.charAt(0)).toLowerCase();

    let params = {
      title_id: user.title,
      first_name: user.firstname,
      last_name: user.lastname,
      nickname: nickname,
      role_start: user.role_start,
      invited_by: user.invited_by,
      guest_id: user.guest_id,
    };

    if (user.photo64 != null) {
      params["photo"] = user.photo64;
      params["photo_thumbnail"] = user.photo64;
    }

    var full_api_url = API_URL + "register";

    return axios
      .post(full_api_url, params, { headers: { access_token: process.env.VUE_APP_API_KEY } })
      .then(response => {
        return response.data;
      });
  }


  findByName(user) {
    var full_api_url = API_URL + "find?first_name=" + user.firstname + "&last_name=" + user.lastname;

    return axios
      .get(full_api_url, { headers: { access_token: process.env.VUE_APP_API_KEY } })
      .then(response => {
        return response.data;
      });
  }

  findByEmail(user) {
    var full_api_url = API_URL + "find?email=" + user.email;

    return axios
      .get(full_api_url, { headers: { access_token: process.env.VUE_APP_API_KEY } })
      .then(response => {
        return response.data;
      });
  }

  updateGuest(user_id, guest_id, is_client) {

    let params = {
      id: guest_id,
      guest_user_id: user_id,
      is_guest_client: is_client
    };

    var full_api_url = API_URL + "update/invite";

    return axios
      .put(full_api_url, params, { headers: { access_token: process.env.VUE_APP_API_KEY } })
      .then(response => {
        return response.data;
      });
  }
}



export default new GuestService();
